import * as React from "react";

import Main from "./Main";

import LoadingComponent from "./LoadingComponent";
import { LoadingProvider } from "../../../../../context/LoadingContext";
import { MCSContextProvider } from "./MCS.context";

export default function MCSPage({ plant = false }) {
  return (
    <LoadingProvider>
      <MCSContextProvider plant={plant}>
        <LoadingComponent />
        <Main />
      </MCSContextProvider>
    </LoadingProvider>
  );
}
